



















































import Vue from 'vue';
import { Game } from '@/game/model';
import { isGameLost, isGameWon } from '@/game/scoring';

export default Vue.component('Help', {
  data() {
    return {
      helpVisible: false
    };
  }
});
